export const PremiumUpgradePrompt = ({ currentZip, occupation }) => {
  return (
    <div className="bg-gradient-to-r from-yellow-50 to-orange-50 border border-yellow-200 rounded-lg p-6 mb-6">
      <div className="flex">
        <div className="flex-shrink-0">
          <svg className="h-6 w-6 text-yellow-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
          </svg>
        </div>
        <div className="ml-3 flex-1">
          <h3 className="text-lg font-medium text-yellow-800">
            Unlock ZIP-level Salary Insights
          </h3>
          <div className="mt-2 text-sm text-yellow-700">
            <p className="mb-2">
              Get detailed salary data for {occupation?.title} specifically in ZIP code {currentZip}, including:
            </p>
            <ul className="list-disc list-inside space-y-1 mb-4">
              <li>Local metro area salary ranges</li>
              <li>Neighborhood-specific data</li>
              <li>Cost of living adjustments</li>
              <li>Comparison with nearby areas</li>
              <li>Historical salary trends</li>
            </ul>
            <p className="text-sm text-yellow-600">
              Currently showing: State and national averages only
            </p>
          </div>
          <div className="mt-4">
            <a
              href="/subscription-management"
              className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-yellow-800 bg-yellow-200 hover:bg-yellow-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500"
            >
              Upgrade to Premium
              <svg className="ml-2 -mr-1 h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </a>
          </div>
        </div>
        
        {/* Premium badge */}
        <div className="flex-shrink-0">
          <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800">
            Premium Feature
          </span>
        </div>
      </div>
    </div>
  );
};